<script setup>
import BulkUserUploadBox from "./BulkUserUploadBox.vue";
</script>

<template>
  <div class="bulk-modal-overlay" @click.self="$emit('close-modal')">
    <div class="bulk-modal" role="dialog" aria-modal="true" aria-label="Bulk user upload">
      <div class="bulk-modal-head" :style="{ backgroundColor: brandData?.main_color1 || '#0e5071' }">
        <span class="bulk-modal-title">Bulk user upload</span>
        <button type="button" class="bulk-modal-close" aria-label="Close" @click="$emit('close-modal')">&times;</button>
      </div>

      <div class="bulk-modal-body">
        <p class="bulk-modal-note">
          Download this:
          <a href="/storage/userTemplates/bulk_user_upload.csv" download="bulk_user_upload.csv" target="_blank">CSV template.</a>
          All columns are mandatory. In the roles column, when in doubt, use PARTICIPANT.
        </p>
        <BulkUserUploadBox buttonLabel="Create" :passedUserData="userData" :brandData="brandData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminDashboardBulkUploadModal",
  props: ["userData", "brandData"],
  emits: ["close-modal"],
};
</script>

<style scoped>
.bulk-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}
.bulk-modal {
  background: #fff;
  width: 100%;
  max-width: 820px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}
.bulk-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  color: #fff;
  flex-shrink: 0;
}
.bulk-modal-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.bulk-modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}
.bulk-modal-body {
  padding: 16px 20px 20px;
  overflow-y: auto;
}
.bulk-modal-note {
  font-size: 13px;
  margin: 0 0 12px;
}
.bulk-modal-body :deep(.form-container) {
  width: 100%;
  padding: 0;
}
</style>